import React from "react";

const AuthCenteredLayout = ({ maxWidthClass = "max-w-md", children }) => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center px-4 sm:px-6">
      <div className={`w-full ${maxWidthClass}`}>
        {children}
      </div>
    </div>
  );
};

export default AuthCenteredLayout;
